import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType, Flex } from 'modules/ui';
import { DownloadLeasingOfferDetails } from 'modules/leasingOffersPage/components/helper';
import { OfferOverviewTab } from '../offerOverviewTab';
import { LeasingOfferDetails } from '../../../types/LeasingOffer';

export interface LeasingOfferOverviewLayoutProps {
  onSubmit?: () => void;
  onPrevious?: () => void;
  data?: LeasingOfferDetails;
  useLocalData?: boolean;
}

export const LeasingOfferOverviewLayout: React.FC<
  LeasingOfferOverviewLayoutProps
> = ({ onSubmit, onPrevious, data, useLocalData }) => {
  const { t } = useTranslation();

  return (
    <>
      <OfferOverviewTab offerOverviewData={data} />

      {/* buttons container */}
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        maxWidth="55rem"
        margin="9rem 0 0 0"
        flexWrap="wrap"
        verticalGap="2.5rem">
        {onPrevious && (
          <Button
            text={t('form.formButtons.previousStep')}
            type={ButtonType.Secondary}
            onClick={onPrevious}
          />
        )}
        <Flex
          flexDirection="row"
          gap="2.5rem"
          verticalGap="2.5rem"
          flexWrap="wrap">
          {data && (
            <DownloadLeasingOfferDetails
              leasingOfferId={data?.id}
              localData={useLocalData ? data : undefined}
              buttonText={t('leasingOfferOverviewPage.downloadOffer')}
              buttonType={ButtonType.Primary}
            />
          )}
        </Flex>
      </Flex>
    </>
  );
};
